module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-hide bbh",
    staticStyle: {
      "text-align": "center",
      "padding-top": "40%",
      "font-size": "35px",
      "color": "#50a200"
    }
  }, [_vm._v("\n  错误\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bea03198"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/main/views/gowhere.vue
// module id = 221
// module chunks = 1